import React, { useEffect } from 'react';
import styles from 'src/app/surveys/views/new-survey-design/NewSurveyDesign.module.scss';
import StandardAppLayout from 'src/shared/components/layout/standard-app-layout/StandardAppLayout';
import { useAppDispatch } from 'src/store';
import { useAppSelector } from 'src/store';
import { reset } from 'src/app/habitat-insights/state/addSiteToPlatformSlice';
import { getCurrentAddSiteToPlatformFormState } from 'src/app/habitat-insights/state/addSiteToPlatformSelector';
import useAddSiteToPlatform from './hooks/useAddSiteToPlatform';
import HabitatInsightsUploadAddSite from './components/habitat-insights-upload/HabitatInsightsUploadAddSite';
import BasicInformationAddSite from './components/basic-information/BasicInformationAddSite';

const AddSiteToPlatform = () => {
    const dispatch = useAppDispatch();
    const formState = useAppSelector(getCurrentAddSiteToPlatformFormState);
    const { onFormChange } = useAddSiteToPlatform();

    useEffect(() => {
        dispatch(reset());
        onFormChange({
            formMode: 'CREATE',
        });
    }, [dispatch, onFormChange]);

    const isUploadDisabled = !Boolean(
        formState.country && (formState.customerId || formState.customerName) && (formState.projectId || formState.projectName)
    );

    const mainContent = (
        <div className='h-full overflow-auto pb-[50px]'>
            <div className={styles.formView}>
                <div className={styles.formViewTitle}>Add Site to Platform</div>
                <BasicInformationAddSite />
            </div>
            <div className='mt-10'>
                <HabitatInsightsUploadAddSite isDisabled={isUploadDisabled} />
            </div>
        </div>
    );

    return <StandardAppLayout mainContent={mainContent} title={'Add Site to Platform'} />;
};

export default AddSiteToPlatform;
